import React, { useEffect, useRef, useState } from "react";
import L from "leaflet";
import 'leaflet/dist/leaflet.css';
import {
    addLayertToLegend,
    clearLayerLegend,
    createControl,
    createMap,
    initMinimalMap,
    initModalLegend,
    initOutlineCity
} from "../../utils/map/mapUtils";
import { onlyUniqueByKey } from "../../utils/overlaysUtils";
require("../../utils/leaflet/Leaflet.VectorGrid.bundled");

export const MapWithTiles = ({sectionId, selectedItem, locationInfos, outlineCity, onChangeLegend}) => {
    const [alternativeText, setAlternativeText] = useState(undefined);
    const mapRef = useRef(undefined);
    const overlaysGroupRef = useRef(undefined);
    const legendRef = useRef(undefined);
    const mobileLegendRef = useRef(undefined);
    const outlineCityRef = useRef(undefined);

    useEffect(() => {
        if(sectionId && outlineCity){
            mapRef.current = createMap(sectionId);
            legendRef.current = createControl('topleft', false, true);
            mobileLegendRef.current = createControl('topleft', false, true);
            outlineCityRef.current = initOutlineCity(outlineCity);

            overlaysGroupRef.current = L.layerGroup().addTo(mapRef.current);

            initMinimalMap(mapRef.current, legendRef.current, outlineCityRef.current, locationInfos);
            initModalLegend(mobileLegendRef.current, locationInfos, mapRef.current, selectedItem.label);
        }
    }, [])

    useEffect(() => {
        if(mapRef.current && legendRef.current && mobileLegendRef.current){
            overlaysGroupRef.current.clearLayers();
            mapRef.current.fitBounds(locationInfos.address
                ? L.latLngBounds([locationInfos.address.lat + 0.03, locationInfos.address.lon + 0.03], [locationInfos.address.lat - 0.03, locationInfos.address.lon - 0.03])
                : outlineCityRef.current.getBounds()
            );
            const tilesId = selectedItem.tilesId || selectedItem.id;
            if(tilesId && !selectedItem.hasMissingData){
                //legend values & tile
                fetch(`/values/${tilesId}`)
                    .then(res => res.json())
                    .then(values => {
                        const formattedValues = selectedItem.legend ? selectedItem.legend(values) : values.filter(onlyUniqueByKey("label"));
                        addLayertToLegend(selectedItem, formattedValues, legendRef.current);
                        onChangeLegend(formattedValues);
                        // Renew legend button
                        if (mobileLegendRef.current) {
                            mobileLegendRef.current.remove();
                            initModalLegend(mobileLegendRef.current, locationInfos, mapRef.current, selectedItem.label);
                        }
                        return formattedValues;
                    })
                    .then(legends => {
                        overlaysGroupRef.current.addLayer(L.vectorGrid.protobuf(`/tiles/${tilesId}/{z}/{x}/{y}.pbf`, {
                            interactive: true,
                            vectorTileLayerStyles: {[tilesId]: (properties) => selectedItem.style(properties, legends)},
                            attribution: selectedItem.attributions ? `© ${selectedItem.attributions}` : null,
                            zIndex: 10
                        })
                        .on('click', (layerElement) => {
                            const content = selectedItem.popupContent(layerElement.layer.properties);
                            if(content){
                                L.popup()
                                .setLatLng(layerElement.latlng)
                                .setContent(content)
                                .openOn(mapRef.current);
                            }
                        }))
                    })
            } else {
                clearLayerLegend(legendRef.current);
            }
            setAlternativeText(selectedItem.alternativeText ? selectedItem.alternativeText : undefined);
        }
    }, [selectedItem])
    return (
        <div className="dashboard-map">
            {/* if missing data for the selectedItem */}
            {selectedItem && selectedItem.hasMissingData &&
                <div className="no-data">
                    <p>
                        <i className="maificon maificon-exclamation-cercle pr-2" aria-hidden="true"></i>
                        <span> Les données ne sont pas disponibles pour cette commune</span>
                    </p>
                </div>
            }
            {sectionId &&
                <div
                    id={`${sectionId}-map`}
                    style={{ height: '100%'}}
                    role="img"
                    aria-label={alternativeText ?  alternativeText : `Carte de la ville : ${locationInfos.com.libelle}`}
                >
                </div>
            }
        </div>
    )
}